<script lang="ts">
    let { rating = 0, onchange }: { rating?: number; onchange: (rating: number) => void } = $props()

    let hovered = $state(0)

    function select(star: number) {
        rating = star
        onchange(star)
    }
</script>

<div class="star-rating" role="radiogroup" aria-label="Bewertung">
    {#each [1, 2, 3, 4, 5] as star}
        <button
            type="button"
            class="star"
            class:filled={star <= (hovered || rating)}
            onmouseenter={() => (hovered = star)}
            onmouseleave={() => (hovered = 0)}
            onclick={() => select(star)}
            aria-label="{star} {star === 1 ? 'Stern' : 'Sterne'}"
            role="radio"
            aria-checked={star === rating}
        >
            ★
        </button>
    {/each}
</div>

<style lang="less">
    .star-rating {
        display: flex;
        gap: 0.25rem;
    }

    .star {
        background: none;
        border: none;
        cursor: pointer;
        font-size: 2rem;
        color: #ccc;
        padding: 0;
        line-height: 1;
        transition:
            color 0.15s,
            transform 0.15s;

        &.filled {
            color: #f5a623;
        }

        &:hover {
            transform: scale(1.15);
        }

        &:focus-visible {
            outline: 2px solid var(--primary, #f5a623);
            outline-offset: 2px;
            border-radius: 2px;
        }
    }
</style>
